import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Rate from "../Images/Rate.png";
import Mira from "../Images/Mira.jpg";
import Zulas from "../Images/Zulas.jpg";
// import Helptag from "../Images/Company/Help.jpeg";
// import Dairy from "../Images/Company/Dairy.png";
// import Radha from "../Images/Company/Radha.jpeg";
// import Raha from "../Images/Company/Raha.png";
// import WBA from "../Images/Company/WBA.png";
// import A995 from "../Images/Company/99.5.png";
// import BN from "../Images/Company/BN.png";
// import Silver from "../Images/Company/SS.png";
// import GMS from "../Images/Company/GMS.png";
// import Atithi from "../Images/Company/Atithi.jpeg";
// import Logo from "../Images/Logo.png";
import CC from "../Images/Company/CC.jpg";
const TabComponent = () => {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("activeTab") || "Web Development"; // Get from localStorage
  });

  // Store tab changes in localStorage
  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  return (
    <div className="bg-gray-900 relative text-white py-10 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <button className="md:w-[254px] w-[200px] bg-[#432DD7] md:h-[67px] h-[50px] rounded-full text-[20px] font-[Nunito]">
            Featured Projects
          </button>
          <h2
            className="md:text-[40px] text-[26px] font-[700]"
            style={{ fontFamily: "PT Sans" }}
          >
            Featured Projects highlighting excellence
          </h2>
          <p className="font-[Allison] text-[25px] md:text-[40px]">
            in design, development, and user experience.
          </p>
          <p className="text-gray-400 md:text-[16px] text-[12px] font-[400] font-[Nunito]">
            Highlighting some of our most innovative and impactful work...
          </p>
        </motion.div>

        {/* Tabs */}
        <div className="flex flex-col items-center mt-8">
          <div className="flex overflow-x-auto md:overflow-hidden w-full md:w-auto mb-6">
            <div className="md:bg-gray-800 p-2 rounded-full flex gap-2 min-w-full md:min-w-0 justify-between">
              {["Web Development", "App Development"].map((tab) => (
                <motion.button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`whitespace-nowrap py-2 px-4 sm:px-2 rounded-full transition-all ${
                    activeTab === tab
                      ? "bg-[#432DD7] text-white"
                      : "text-gray-300"
                  }`}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {tab}
                </motion.button>
              ))}
            </div>
          </div>

          {/* Content Area */}
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-gray-800 rounded-lg p-6 shadow-lg w-[300px] md:w-auto"
          >
            {activeTab === "Web Development" && <WebDevelopment />}
            {activeTab === "App Development" && <AppDevelopment />}
            {/* {activeTab === "Social Media Management" && <SocialMediaManagement />} */}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default TabComponent;

const WebDevelopment = () => {
  return (
    <>
      {/* First Section */}
      <motion.div
        className="flex flex-col md:flex-row"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="md:w-[50%]">
          <img
            src={Zulas}
            alt="Project"
            className="md:w-[500px] h-[200px] w-full md:h-[547px] rounded-xl"
          />
        </div>
        <div className="p-5 md:w-[50%]">
          <h2 className="text-[15px] w-[200px] text-[#9c7248] font-[Nunito] font-[300]">
            Featured Project
          </h2>
          <h2
            className="text-[24px] text-[#9c7248] w-[300px] font-[700]"
            style={{ fontFamily: "PT Sans" }}
          >
            Zulaz & More
          </h2>
          <h2 className="text-[16px] font-[Nunito] md:w-[500px] font-[300] text-justify">
            ​Zulas n More is a premier swing manufacturer based in Ahmedabad,
            Gujarat, India, renowned for offering an extensive array of
            high-quality swings. Their product line includes over 200 varieties,
            such as acrylic swings, wooden swings, outdoor swings, indoor
            swings, standing zulas, one-seaters, and sofa-cum-zulas. Emphasizing
            modern, sustainable, and handcrafted designs, Zulas n More allows
            customers to customize swings to complement their existing
            furniture.
          </h2>
          <br />
          <div>
            <img src={Rate} alt="Rating" />
          </div>
          <div className="mt-5">
            <a
              href="https://www.figma.com/design/kyMhLG7FYybLBZvqemUtrJ/Zulaz-and-More?node-id=0-1&p=f&t=QuKZwGXdqxEKaawy-0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <motion.button
                className="text-[#9c7248] border p-4 font-[Nunito] rounded-xl"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="fa-solid fa-users-viewfinder"></i>&nbsp;&nbsp;View
                Project
              </motion.button>
            </a>
          </div>
        </div>
      </motion.div>

      {/* Second Section (Reversed for Mobile) */}
      <motion.div
        className="flex flex-col-reverse md:flex-row mt-10"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="mt-5 md:w-[50%]">
          <h2 className="text-[15px] w-[200px] text-[#ff8503] font-[Nunito] font-[300]">
            Featured Project
          </h2>
          <h2
            className="text-[24px] text-[#ff8503] w-[300px] font-[700]"
            style={{ fontFamily: "PT Sans" }}
          >
            Meerambeena Motel
          </h2>
          <h2 className="text-[16px] font-[Nunito] md:w-[500px] font-[300] text-justify">
            Mirambeena Motel is a comfortable accommodation option located at 23
            Essington Lewis Avenue, Whyalla, South Australia. The motel
            specializes in both short and long-term stays, catering particularly
            to contractors working in and around the Whyalla area.
          </h2>
          <h2 className="text-[16px] font-[Nunito] md:w-[500px] font-[300] text-justify">
            Rooms: The motel offers 46 air-conditioned rooms equipped with Smart
            televisions and complimentary Wi-Fi access. Housekeeping services
            are available upon request. Facilities: Guests can enjoy an outdoor
            swimming pool, free private parking, and a garden area. Additional
            amenities include laundry facilities and an on-site restaurant.
          </h2>
          <br />
          <div>
            <img src={Rate} alt="Rating" />
          </div>
          <div className="mt-5">
            <a
              href="https://www.figma.com/design/VhDsaFpjNrz2lGI5yFo3Sd/Mirambeena-Motel?node-id=0-1&p=f&t=Kon15NVuu106uoY7-0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <motion.button
                className="text-[#ff8503] border p-4 font-[Nunito] rounded-xl"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="fa-solid fa-users-viewfinder"></i>&nbsp;&nbsp;View
                Project
              </motion.button>
            </a>
          </div>
        </div>
        <div className="md:w-[50%]">
          <img
            src={Mira}
            alt="Project"
            className="md:w-[500px] h-[200px] w-full md:h-[547px] rounded-xl"
          />
        </div>
      </motion.div>
    </>
  );
};

const AppDevelopment = () => {
  return (
    <>
      <motion.div
        className="flex flex-col md:flex-row"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="md:w-[50%]">
          <img
            src={CC}
            alt="Project"
            className="md:w-[500px] h-[200px] w-full md:h-[547px] object-cover rounded-xl"
          />
        </div>
        <div className="p-5 md:w-[50%]">
          <h2 className="text-[15px] w-[200px] text-[#9c7248] font-[Nunito] font-[300]">
            Featured Project
          </h2>
          <h2
            className="text-[24px] text-[#9c7248] w-[300px] font-[700]"
            style={{ fontFamily: "PT Sans" }}
          >
            CricControl
          </h2>
          <h2 className="text-[16px] font-[Nunito] md:w-[500px] font-[300] text-justify">
            CricControl is your ultimate destination for live cricket action,
            offering real-time scorecards, detailed match schedules, and
            in-depth statistics — all in one sleek and easy-to-use app. Whether
            you're tracking international fixtures, T20 leagues like the IPL, or
            domestic tournaments, CricControl keeps you updated with
            ball-by-ball commentary, player insights, and upcoming match
            schedules. Stay ahead of the game with smart notifications, clean
            visuals, and the fastest score updates — only with CricControl!
          </h2>
          <br />
          <div>
            <img src={Rate} alt="Rating" />
          </div>
          <div className="mt-5">
            <a
              href="https://www.figma.com/design/6Kq1wjMRf3wb5B5uW3IzZy/Folder---4?node-id=0-3&p=f&t=KH2OZYlqMy54zDg8-0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <motion.button
                className="text-[#9c7248] border p-4 font-[Nunito] rounded-xl"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="fa-solid fa-users-viewfinder"></i>&nbsp;&nbsp;View
                Project
              </motion.button>
            </a>
          </div>
        </div>
      </motion.div>
    </>
  );
};

// const SocialMediaManagement = () => {
//   return (
//     <>
//       <div className="grid grid-cols-1 md:grid-cols-3 md:gap-15">
//         <div>
//           <img src={Helptag} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div>
//           <img src={Radha} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div>
//           <img src={Logo} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div>
//           <img src={Dairy} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div>
//           <img src={Atithi} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div>
//           <img src={Raha} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div>
//           <img src={WBA} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div>
//           <img src={BN} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div className="bg-white">
//           <img src={Silver} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div>
//           <img src={GMS} alt="" className="w-[200px] h-[200px]" />
//         </div>
//         <div>
//           <img src={A995} alt="" className="w-[200px] h-[200px]" />
//         </div>
//       </div>
//     </>
//   );
// };
